import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for `/rates/*` — `rates.$listingId.tsx` sits alongside this
 * file, which makes TanStack Router treat this file as the PARENT of
 * `/rates/$listingId` (see `bookings.tsx`'s comment for the full
 * explanation of the flat file-route pitfall; task 13's fix note flagged
 * this exact file as having the identical shape). The listing picker lives
 * in `rates.index.tsx` (`/rates/`).
 */
export const Route = createFileRoute('/rates')({
  component: RatesLayout,
});

function RatesLayout() {
  return <Outlet />;
}
